// extracted by mini-css-extract-plugin
export default {"logo-box":"Logo_logo-box__gT8PS","logo-text":"Logo_logo-text__oqx4o","logo-icon":"Logo_logo-icon__fccW0"};